;
/*!
 * subitotexto.expandinggrid.js
 */
(function ( $ ) {

	SubitoTexto.expandingGrid = {
		init       : function () {
			var $ = jqPla,
				_this = SubitoTexto.expandingGrid;

			_this.$gridContainer = $( '.expanding-grid' );
			_this.scrollToSpeed = 800;

			// No use in doing anything else if what we're targetting isn't on this page
			if ( _this.$gridContainer.length > 0 ) {

				_this.$allBlocks = _this.$gridContainer.find( '.grid-item' );
				_this.$detailBlocks = _this.$gridContainer.find( '.vedette-content' );
				_this.$allRows = _this.$gridContainer.find( '.grid-row' );
				_this.activeRow = 0;
				_this.$activeElement = false;

				_this.currentMode = PLA.UTILS.areWeMobile();

				_this.scrollOffset = 100;

				_this.bindEvents();

				_this.initialView();
			}
		},
		initialView: function () {
			var $ = jqPla,
				_this = SubitoTexto.expandingGrid;

			var currHash = window.location.hash;


			// if ( currHash ) {
			//
			// 	//	currHash = currHash.replace( '#', '' );
			//
			// 	var $wanted = _this.$allBlocks.filter( '[href="' + currHash + '"]' );
			//
			// 	if ( $wanted.length == 0 ) {
			// 		// These are not the droids you are looking for
			// 		// (This hash doesn't match any of the content)
			// 		return false;
			// 	}
			//
			// 	$wanted.trigger( 'click' );
			// }

		},
		bindEvents : function () {
			var $ = jqPla,
				_this = SubitoTexto.expandingGrid;


			// What to do when we click on a block
			_this.$gridContainer.on( 'click', '.grid-item', function ( e ) {
				e.stopPropagation();
				e.preventDefault();


				_this.openDetails( $( this ), e );

			} );

			_this.$gridContainer.on( 'click', '.close-btn', function ( e ) {
				e.preventDefault();

				_this.closeDetails();

				//_this.removeHash();
			} );


			// Shift Tab from inside the details with the close button sleected
			_this.$gridContainer.on( 'keydown', '.close-btn', function ( e ) {
				var $this = $( this );
				var hasGallery = _this.$currentDetails.find( '.vedette-description-gallery-container' ).hasClass( 'has-gallery' );


				if ( e.shiftKey == true && e.keyCode === PLA.a11y.keys.tab ) {
					// _this.closeDetails();

					e.preventDefault();

					if ( hasGallery ) {
						var $nextArrow = _this.$currentDetails.find( '.slick-next.slick-arrow' ),
							$lastLauncher = _this.$currentDetails.find( '.gallery-item-launcher' ).last();

						// If the right/next arrow is not disabled, it should be the last element
						// if it IS disabled, we're at the end of the carousel and should focus the last launcher item
						if ( $nextArrow.length > 0 && !$nextArrow.hasClass( 'slick-disabled' ) ) {
							$nextArrow.focus();
						} else {
							$lastLauncher.focus();
						}
					} else {

					}

				} else if ( !hasGallery && e.shiftKey == false && e.keyCode === PLA.a11y.keys.tab ) {
					e.preventDefault();
				}

				// else if (
				// 	( e.shiftKey != true && e.keyCode === PLA.a11y.keys.tab ) &&
				// 	$this.siblings( '.details-content' ).find( '.vedette-description-gallery-container' ).hasClass( 'no-gallery' )
				// ) {
				// 	var activeGridItemIndex = _this.$allBlocks.index( _this.$activeElement );
				// 	_this.closeDetails( _this.$allBlocks.eq( activeGridItemIndex ) );
				// }

			} );


			_this.$gridContainer.on( 'keydown', function ( e ) {


				// Esc to close the details
				if ( e.keyCode === PLA.a11y.keys.esc ) {
					_this.closeDetails();
				}

				// Shift-TAB w
				else if ( e.shiftKey != true && e.keyCode === PLA.a11y.keys.tab ) {
					var $originallyOn = $( e.target ),
						$nowOn = $( e.currentTarget ),
						isLastLauncher = $originallyOn.hasClass( 'last-launcher' ),
						isNextButton = $originallyOn.hasClass( 'slick-next' );

					if ( isLastLauncher || isNextButton ) {
						// The following code would activate the next element (grid item)
						// var activeGridItemIndex = _this.$allBlocks.index( _this.$activeElement );
						// _this.closeDetails( _this.$allBlocks.eq( activeGridItemIndex ) );

						e.preventDefault();
						_this.$currentDetails.find( '.close-btn' ).focus();
					}
				}

			} );


			// Destroy the effect if we'Re going from desktop to mobile and vice versa
			var debounceModeSwitch = PLA.UTILS.debounce( function () {

				var currentMode = PLA.UTILS.areWeMobile();

				if ( currentMode != _this.currentMode ) {
					_this.destroyDetails();
					_this.$activeElement = false;
					_this.$allBlocks.removeClass( 'active' );
					//	_this.removeHash();

					_this.currentMode = currentMode;
				}
			}, 250 );

			window.addEventListener( 'resize', debounceModeSwitch );


		},

		openDetails: function ( $target, event ) {
			var $ = jqPla,
				_this = SubitoTexto.expandingGrid;


			var dataHash = $target.attr( 'href' ).replace( '#', '' );


			if ( !$target.hasClass( 'active' ) ) {
				//console.log('Showing block');

				_this.$activeElement = $target;


				if ( PLA.UTILS.areWeMobile() ) {
					_this.placeDetailsMobile( $target );
				} else {
					_this.placeDetailsDesktop( $target );
				}

				$target.addClass( 'active' );

				//window.location.hash = dataHash;

			} else {

				_this.destroyDetails();
				_this.$activeElement = false;
				_this.$allBlocks.removeClass( 'active' );

				//	_this.removeHash();
			}

			_this.$allBlocks.not( $target ).removeClass( 'active' );

			_this.$allBlocks.attr( 'aria-hidden', true );
		},

		closeDetails: function ( $forceElementFocus ) {
			var $ = jqPla,
				_this = SubitoTexto.expandingGrid;

			_this.destroyDetails();

			if ( $forceElementFocus ) {
				_this.$activeElement = $forceElementFocus;
			}

			_this.$activeElement.focus();

			setTimeout( function () {
				$( 'html, body' ).animate( { scrollTop: ( _this.$activeElement.offset().top - _this.scrollOffset  ) }, _this.scrollToSpeed );
				_this.$activeElement = false;
			}, 100 );

			_this.$allBlocks.removeClass( 'active' );

			_this.$allBlocks.attr( 'aria-hidden', false );

		},

		setupVedettesGallery: function () {
			var $ = jqPla,
				_this = SubitoTexto.expandingGrid;

			var $gallery = _this.$currentDetails.find( '.vedette-gallery' );
			if ( $gallery.length > 0 ) {
				$gallery.vedettesGallery();
			}

		},

		placeDetailsDesktop: function ( $activatedBlock ) {
			var $ = jqPla,
				_this = SubitoTexto.expandingGrid;

			var $currRow = $activatedBlock.parents( '.grid-row' ),
				indexCurrRow = _this.$allRows.index( $currRow ),
				thisDetailsId = $activatedBlock.attr( 'href' ),
				$thisDetails = _this.$detailBlocks.filter( thisDetailsId );


			if ( typeof _this.$currentDetails !== 'undefined' && _this.$currentDetails.length > 0 && indexCurrRow != _this.activeRow ) {
				// Slide up the old one
				_this.$currentDetails.stop().slideUp( 350, function () {
					_this.destroyDetails( true );

					_this.$currentDetails = $( '<div class="details-container" role="dialog"><button class="close-btn"><span class="sr-only">Fermer les détails</span>' + _this.closeSvg + '</button><div class="details-content clearfix"></div></div>' ).insertAfter( $currRow ).hide();

					_this.$currentDetails.find( '.details-content' ).html( $thisDetails.html() ).fadeTo( 0, 0.01 );

					// Aria Dialog
					var $heading = _this.$currentDetails.find( '.vedette-description-name' ),
						currHeadingId = $heading.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 ),
						$currContent = _this.$currentDetails.find( '.vedette-description-content' ),
						currContentId = $currContent.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 );

					$heading.attr( 'id', currHeadingId );
					_this.$currentDetails
						.attr( 'aria-labelledby', currHeadingId )
						.attr( 'aria-describedby', currContentId );
					$currContent.attr( 'id', currContentId );
					// !Aria dialog


					setTimeout( function () {
						$( 'html, body' ).animate( { scrollTop: ( _this.$currentDetails.offset().top - _this.scrollOffset  ) }, _this.scrollToSpeed );

					}, 100 );


					_this.$currentDetails.stop().slideDown( 350, function () {

						_this.$currentDetails.find( '.details-content' ).fadeTo( 350, 1, function () {
							_this.activeRow = indexCurrRow;

							_this.setupVedettesGallery();
							_this.$currentDetails.find( '.close-btn' ).focus();
						} );
					} );

				} );


			} else if ( typeof _this.$currentDetails !== 'undefined' && _this.$currentDetails.length > 0 && indexCurrRow == _this.activeRow ) {


				//same row, different details

				_this.$currentDetails.find( '.details-content' ).stop().fadeTo( 'fast', 0.01, function () {
					_this.$currentDetails.find( '.details-content' ).html( $thisDetails.html() );

					// Aria Dialog
					var $heading = _this.$currentDetails.find( '.vedette-description-name' ),
						currHeadingId = $heading.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 ),
						$currContent = _this.$currentDetails.find( '.vedette-description-content' ),
						currContentId = $currContent.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 );

					$heading.attr( 'id', currHeadingId );
					_this.$currentDetails
						.attr( 'aria-labelledby', currHeadingId )
						.attr( 'aria-describedby', currContentId );
					$currContent.attr( 'id', currContentId );
					// !Aria dialog


					_this.$currentDetails.find( '.details-content' ).fadeTo( 350, 1, function () {
						_this.activeRow = indexCurrRow;
						_this.setupVedettesGallery();
						_this.$currentDetails.find( '.close-btn' ).focus();
					} );
				} );

			} else {

				_this.$currentDetails = $( '<div class="details-container" role="dialog"><button class="close-btn"><span class="sr-only">Fermer les détails</span>' + _this.closeSvg + '</button><div class="details-content clearfix"></div></div>' ).insertAfter( $currRow ).hide();

				_this.$currentDetails.find( '.details-content' ).html( $thisDetails.html() ).fadeTo( 0, 0.01 );


				// Aria Dialog
				var $heading = _this.$currentDetails.find( '.vedette-description-name' ),
					currHeadingId = $heading.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 ),
					$currContent = _this.$currentDetails.find( '.vedette-description-content' ),
					currContentId = $currContent.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 );

				$heading.attr( 'id', currHeadingId );
				_this.$currentDetails
					.attr( 'aria-labelledby', currHeadingId )
					.attr( 'aria-describedby', currContentId );
				$currContent.attr( 'id', currContentId );
				// !Aria dialog

				setTimeout( function () {
					$( 'html, body' ).animate( { scrollTop: ( _this.$currentDetails.offset().top - _this.scrollOffset  ) }, _this.scrollToSpeed );

				}, 100 );

				_this.$currentDetails.slideDown( 'fast', function () {
					_this.$currentDetails.find( '.details-content' ).fadeTo( 500, 1, function () {
						_this.activeRow = indexCurrRow;
						_this.setupVedettesGallery();
						_this.$currentDetails.find( '.close-btn' ).focus();
					} );
				} );


			}


		},


		placeDetailsMobile: function ( $activatedBlock ) {
			var $ = jqPla,
				_this = SubitoTexto.expandingGrid;

			// where always appending the details after the last of THIS row

			var isLeft = _this.$allBlocks.index( $activatedBlock ) % 2 == 0,
				$nextBlock = $activatedBlock.nextAll( '.vedette-header' ).eq( 0 ),
				$whereToAppend = isLeft ? $nextBlock : $activatedBlock,

				indexCurrRow = _this.$allBlocks.index( $whereToAppend ),
				thisDetailsId = $activatedBlock.attr( 'href' ),
				$thisDetails = _this.$detailBlocks.filter( thisDetailsId );


			if ( typeof _this.$currentDetails !== 'undefined' && _this.$currentDetails.length > 0 && indexCurrRow != _this.activeRow ) {
				// Slide up the old one
				_this.$currentDetails.stop().slideUp( 350, function () {
					_this.destroyDetails( true );

					_this.$currentDetails = $( '<div class="details-container" role="dialog"><button class="close-btn"><span class="sr-only">Fermer les détails</span>' + _this.closeSvg + '</button><div class="details-content clearfix"></div></div>' ).insertAfter( $whereToAppend ).hide();


					_this.$currentDetails.find( '.details-content' ).html( $thisDetails.html() ).fadeTo( 0, 0.01 );


					// Aria Dialog
					var $heading = _this.$currentDetails.find( '.vedette-description-name' ),
						currHeadingId = $heading.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 ),
						$currContent = _this.$currentDetails.find( '.vedette-description-content' ),
						currContentId = $currContent.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 );

					$heading.attr( 'id', currHeadingId );
					_this.$currentDetails
						.attr( 'aria-labelledby', currHeadingId )
						.attr( 'aria-describedby', currContentId );
					$currContent.attr( 'id', currContentId );
					// !Aria dialog


					setTimeout( function () {
						$( 'html, body' ).animate( { scrollTop: ( _this.$currentDetails.offset().top - _this.scrollOffset  ) }, _this.scrollToSpeed );

					}, 100 );


					_this.$currentDetails.stop().slideDown( 350, function () {

						_this.$currentDetails.find( '.details-content' ).fadeTo( 350, 1, function () {
							_this.activeRow = indexCurrRow;
							_this.setupVedettesGallery();
							_this.$currentDetails.find( '.close-btn' ).focus();
						} );
					} );

				} );


			} else if ( typeof _this.$currentDetails !== 'undefined' && _this.$currentDetails.length > 0 && indexCurrRow == _this.activeRow ) {


				//same row, different details

				_this.$currentDetails.find( '.details-content' ).stop().fadeTo( 'fast', 0.01, function () {
					_this.$currentDetails.find( '.details-content' ).html( $thisDetails.html() );

					// Aria Dialog
					var $heading = _this.$currentDetails.find( '.vedette-description-name' ),
						currHeadingId = $heading.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 ),
						$currContent = _this.$currentDetails.find( '.vedette-description-content' ),
						currContentId = $currContent.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 );

					$heading.attr( 'id', currHeadingId );
					_this.$currentDetails
						.attr( 'aria-labelledby', currHeadingId )
						.attr( 'aria-describedby', currContentId );
					$currContent.attr( 'id', currContentId );
					// !Aria dialog


					_this.$currentDetails.find( '.details-content' ).fadeTo( 350, 1, function () {
						_this.activeRow = indexCurrRow;
						_this.setupVedettesGallery();
						_this.$currentDetails.find( '.close-btn' ).focus();
					} );
				} )

			} else {

				_this.$currentDetails = $( '<div class="details-container" role="dialog"><button class="close-btn"><span class="sr-only">Fermer les détails</span>' + _this.closeSvg + '</button><div class="details-content clearfix"></div></div>' ).insertAfter( $whereToAppend ).hide();


				_this.$currentDetails.slideUp( 0 );
				_this.$currentDetails.find( '.details-content' ).html( $thisDetails.html() ).fadeTo( 0, 0.01 );

				// Aria Dialog
				var $heading = _this.$currentDetails.find( '.vedette-description-name' ),
					currHeadingId = $heading.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 ),
					$currContent = _this.$currentDetails.find( '.vedette-description-content' ),
					currContentId = $currContent.attr( 'id' ) + '_' + PLA.UTILS.getRandomIntInclusive( 1, 999999 );

				$heading.attr( 'id', currHeadingId );
				_this.$currentDetails
					.attr( 'aria-labelledby', currHeadingId )
					.attr( 'aria-describedby', currContentId );
				$currContent.attr( 'id', currContentId );
				// !Aria dialog


				setTimeout( function () {
					$( 'html, body' ).animate( { scrollTop: ( _this.$currentDetails.offset().top - _this.scrollOffset  ) }, _this.scrollToSpeed );

				}, 100 );

				_this.$currentDetails.slideDown( 'fast', function () {
					_this.$currentDetails.find( '.details-content' ).fadeTo( 500, 1, function () {
						_this.activeRow = indexCurrRow;
						_this.setupVedettesGallery();
						_this.$currentDetails.find( '.close-btn' ).focus();
					} );
				} );


			}


		},


		destroyDetails: function ( immediately ) {
			var $ = jqPla,
				_this = SubitoTexto.expandingGrid;

			//console.log('Hiding block');


			if ( typeof _this.$currentDetails !== 'undefined' && _this.$currentDetails.length > 0 ) {

				if ( typeof immediately == 'undefined' || immediately == false ) {
					_this.$currentDetails.stop().slideUp( 'fast', function () {
						$( this ).remove();
						delete (_this.$currentDetails);

					} );

				} else {
					_this.$currentDetails.remove();
					delete (_this.$currentDetails);
				}

			}
		},
		centerOfActive: function () {
			var $ = jqPla,
				_this = SubitoTexto.expandingGrid;
		}
		,
		closeSvg      : '<svg version="1.1" class="grid-close-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28.991 29.698" enable-background="new 0 0 28.991 29.698" xml:space="preserve"><g id="XMLID_2_"><line id="XMLID_1_" fill="none" stroke="#333333" stroke-miterlimit="10" x1="0.354" y1="28.638" x2="28.638" y2="0.354"/><line id="XMLID_3_" fill="none" stroke="#333333" stroke-miterlimit="10" x1="28.638" y1="29.345" x2="0.354" y2="1.061"/></g></svg>',
		removeHash    : function () {
			var scrollV, scrollH, loc = window.location;
			if ( "pushState" in history )
				history.pushState( "", document.title, loc.pathname + loc.search );
			else {
				// Prevent scrolling by storing the page's current scroll offset
				scrollV = document.body.scrollTop;
				scrollH = document.body.scrollLeft;

				loc.hash = "";

				// Restore the scroll offset, should be flicker free
				document.body.scrollTop = scrollV;
				document.body.scrollLeft = scrollH;
			}
		}
	};


	$( document ).ready( function () {

		//SubitoTexto.expandingGrid.init();

	} );

})( jqPla );